(ns pfo.task.event-component
  (:require [reagent.core :as reagent :refer [atom]]
            [pfo.task.component :as task]
            [pfo.api :refer [process-error]]
            [pfo.state :as state]
            [promesa.core :as p]
            [goog.string :refer [format]]
            [pfo.collection.model :as collection-model]
            [pfo.link.model :as link-model]
            [pfo.task.model :as model]
            [pfo.util :as util :refer [entity handler reset-from-event date-to-rfc3339 to-value set-location back split-string] :rename {split-string split}]
            [pfo.auth.model :as auth-model :refer [perm has-perm]]
            [pfo.assignment.component :refer [assignments-add-new get-initial-ui-assignments
                                              assignments-add-new-notable
                                              get-collection-ids assignments-table assignment-list assignment-list-with-header]]
            [pfo.link.component :as link]
            [pfo.tz :as tz]
            [pfo.comment.component :as comment-comp]
            [pfo.form :as form :refer [set-checked set-selected option-value checked? reset-choice]]
            ;; [pfo.widget.scroll :as scroll]
            [pfo.widget.calendar :refer [calendar]]
            [pfo.widget.countdown :refer [countdown-for-ability]]
            [cljs-time.coerce :as time-coerce]
            [cljs-time.core :as time-core :refer [plus hours minutes]]
            [cljs-time.format :as time-format]
            [pfo.common.component :refer [header] :as common]
            [pfo.common.model :as common-model]
            [pfo.revroutes :refer [go-to-deletion-waypoint]]))

(declare events-calendar calendar-container-dates occurrences-list-show-more)

(def catom clojure.core/atom)

(defn event-details [options event]
  (let [event (atom event)
        delete-prevention-delete-ability (common-model/delete-prevention-delete-ability (atom nil) @event :group_created_at)
        notify-user-choices (atom nil)
        permitted-user-id-set (catom nil)
        task-linked-items (atom nil)
        occurrence-linked-items (atom nil)
        reccurring? (:recurring @event)
        calendar-expanded? (atom true)
        more-than-one-linked-items? #(or (> (-> @task-linked-items :parents count) 1) (> (-> @task-linked-items :children count) 1))
        load-users (fn [collection-ids]
                     (->> (collection-model/permitted-users {:event-invite true} collection-ids)
                          (p/map (fn [response]
                                   (reset! notify-user-choices response)
                                   (reset! permitted-user-id-set (set (map :id response)))))
                          (process-error)))
        load-linked-items (fn []
                            (->> (link-model/task-links (:id @event))
                                 (p/map #(reset! task-linked-items %))
                                 (process-error))
                            (->> (link-model/occurrence-links (:id @event) (:complete_by @event) "event")
                                 (p/map #(reset! occurrence-linked-items %))
                                 (process-error)))
        comments-summary (atom nil)
        occurence-count (count (:occurrence_slice @event))
        comment-count (atom (get-in @event [:cycle 0 :counters :comment_count]))
        load-comments-summary (fn []
                                (->> (model/event-comments-summary (:key @event))
                                     (p/map (fn [response] (reset! comments-summary (response (keyword (str (:id @event)))))))
                                     (process-error)))]

    (load-linked-items)
    (load-comments-summary)
    (load-users (mapv #(:id %) (:collections @event)))

    (reagent/create-class
      {:component-will-unmount
       (fn [_]
         (util/stop-self-updating! delete-prevention-delete-ability))
       :reagent-render
       (fn []
      [:div.redesign.u-shadow--bottom.c-event-details

       [:div.c-event-details__header.o-main-aside

        [:span.c-event-details__expander {:on-click #(swap! calendar-expanded? not)}
         [:button.c-round-button
          [:span (if @calendar-expanded? "-" "+")]]]

        [:div.o-main-aside__aside--medium {:class (when-not @calendar-expanded? "is-display--none")}
         [events-calendar @event calendar-expanded?]]

        [:main.o-main-aside__main
         [header
          :supertitle (get-in @event [:collections 0 :ancestors 0 :name])
          :title (:name @event)
          :subtitles (list (model/event-time-string @event nil)
                           (when (:all_day @event) "(All day)")
                           (when-let [rule (:rule @event)] (format "(Repeated %s)" (clojure.string/lower-case (:name rule)))))
          :subsubtitle (when-let [category (get-in @event [:category])] [:p.u-font-size--larger [:span.type-circle [:span (:type category)]] (:name category)])
          :aside-title "event"
          :aside-subtitles (list ["Created" (when-let [date (get-in @event [:created_at])] (util/date-reformat date)) ]
                                 ["Modified" (when-let [date (get-in @event [:updated_at])] (util/date-reformat date))])
          :controls [:div.row
                     [:div.edit
                      [countdown-for-ability nil (util/parse-datetime (:created_at @event)) task/task-group-max-manage-age
                       (atom nil) delete-prevention-delete-ability]
                      (perm :can_modify @event [:button {:on-click #(set-location (str "#/event/edit/" (:key @event) "/"))} "Edit"])
                      (when @delete-prevention-delete-ability
                        (perm :can_delete @event [:button {:on-click (fn [ev] (when (js/confirm "Are you sure you want to permanently delete this event?")
                                                                                (->> (model/group-delete (:group_id @event) nil)
                                                                                  (p/map #(go-to-deletion-waypoint :event-list))
                                                                                  (process-error))))} "Delete event"]))]]]
         [:div.o-media
          [assignment-list-with-header {:hide-expander true} (task/get-assignments @event)]

          (when (not-empty (:description @event)) [:div
                                                   [:h4.c-heading [:span "Description"]]
                                                   [:p.u-preserve-whitespace (:description @event)]])

          (when reccurring?
            [:div.linked-items
             [:h4.c-heading.o-margin-elements--md
              [:span "Related Records " (link/linked-items-counter @task-linked-items nil true)]
              [link/link-add-chooser {:exclude-types #{"e"}
                                      :initial-collection-id (:id (first (:collections @event)))
                                      :parent-collection-ids (mapv #(:id %) (:collections @event))
                                      :parent {:type link/type-event
                                               :id (:id @event)
                                               :key (:key @event)}}]]

             [link/linked-items {} [(link/link-map-entry {:parent-type "e" :parent-id (:id @event) :reload load-linked-items} (:children @task-linked-items))
                                          (link/link-map-entry {:items-type "parent"
                                                                :parent-type "e"
                                                                :parent-id (:id @event)
                                                                :reload load-linked-items} (:parents @task-linked-items))]]])]]]

       [:div.c-with-list.o-media
        (when-let [invitations (seq (:invitations @event))]
          [:div.invitations
           [:h4.c-heading [:span "Attendees:"]]
           [:ul
            (doall (for [invitation (filterv #(contains? @permitted-user-id-set (:user_id %)) invitations)]
                     [:li (auth-model/get-full-name invitation)
                      (when-let [status (model/invitation-statii (:status invitation))] [:span.status {:class status} status])]))]])


        (when (not-empty (:location @event)) [:div
                                              [:h4.c-heading [:span "Location"]]
                                              [:p (:location @event)]])

        [:div.linked-items
         [:h4.c-heading.o-margin-elements--md
          [:span "Related Records " (link/linked-items-counter @occurrence-linked-items @task-linked-items true)]
          [link/link-add-chooser {:exclude-types #{"e"}
                                  :initial-collection-id (:id (first (:collections @event)))
                                  :parent-collection-ids (mapv #(:id %) (:collections @event))
                                  :parent {:type link/type-event-occurrence
                                           :id (:id @event)
                                           :complete-by (:complete_by @event)
                                           :key (:key @event)}
                                  :linked-items-documents-download [link/linked-items-documents-download-form
                                                                    (:download_key @occurrence-linked-items)]}]]

         [link/linked-items [] [(link/link-map-entry {:parent-type "eo"
                                                            :parent-id (:occurrence_id @event)
                                                            :reload load-linked-items} (:children @occurrence-linked-items))
                                      (when-not reccurring?
                                        (link/link-map-entry {:items-type "parent"} (:parents @task-linked-items)))
                                      (link/link-map-entry {:items-type "parent"} (:parents @occurrence-linked-items))]]]

        [comment-comp/comments-summary @comments-summary]

        (let [comment-errors (atom {})
              attach-to-all (catom "no")]
          [comment-comp/expandable-conversation-list
           (merge
             {:highlight-comment-id (:highlight-comment-id options)
              :users @notify-user-choices
              :user-perms (:perms @event)
              :rich-text true
              :errors-atom comment-errors
              :reload-cb load-comments-summary
              :comment-count comment-count
              :add-func (fn [conversation conversation-id note subject body notify-user-ids notify-cc-user-ids include-body allow-inbox-reply revised-comment-id]
                          (model/task-add-comment
                            (:id @event)
                            (let [complete-by (:complete_by @event)]
                               (if conversation
                                 (when (:occurrence_id conversation) complete-by)
                                 (when (= @attach-to-all "no") complete-by)))
                            conversation-id
                            note
                            subject
                            body
                            notify-user-ids
                            notify-cc-user-ids
                            include-body
                            allow-inbox-reply
                            "event"
                            revised-comment-id))
              :update-func (fn [comment-id subject body notify-user-ids notify-cc-user-ids include-body allow-inbox-reply]
                             (model/task-update-comment
                               (:id @event)
                               comment-id
                               subject
                               body
                               notify-user-ids
                               notify-cc-user-ids
                               include-body
                               allow-inbox-reply))
              :delete-func (fn [comment-id notify-user-ids]
                             (model/task-delete-comment
                               (:id @event)
                               comment-id
                               notify-user-ids))}
             (when (:recurring @event)
               {:extra-edit-new-conversation-components [:div.attach-to "Attach to: " [:select {:on-change (reset-from-event attach-to-all)}
                                                                                       [:option (option-value @attach-to-all "yes") "All"]
                                                                                       [:option (option-value @attach-to-all "no") "This occurrence (" (util/date-reformat (:complete_by @event)) ")"] ]]}))
           (fn [] (model/task-comments (:id @event) (:complete_by @event) "event"))])]])})))

(defn events-calendar [event calendar-expanded?]
  (let [start-time (if (:all_day event)
                     (util/parse-datetime (:start event))
                     (util/parse-datetime-local (:client_start event)))
        end-time (if (:all_day event)
                     (util/parse-datetime (:end event))
                     (util/parse-datetime-local (:client_end event)))
        view (atom :month)]

    (fn [event]
      [:div.c-event-details__calendar-main

       [calendar-container-dates {:start-time start-time :end-time end-time :all-day? (:all_day event)}]

       [:hr]
       (when (:recurring event) [:p.c-heading--no-top-border "Repeating:"])

       (case @view
         :list [occurrences-list-show-more event model/event-details-silent {:calendar-expanded? calendar-expanded?}]

         :month [:div.t-calendar--small [calendar {:events (fn [start end timezone cb]

                                      (->> (model/event-occurrences
                                             (:id event)
                                             (time-format/unparse (time-format/formatters :date-hour-minute-second) (time-core/date-time (.year start) (inc (.month start)) (.date start)))
                                             (time-format/unparse (time-format/formatters :date-hour-minute-second) (time-core/date-time (.year end) (inc (.month end)) (.date end))))
                                           (p/map (fn [response]
                                                    (cb (clj->js (mapv (fn [event-data]
                                                                         {:id (:id event-data)
                                                                          :key (:key event-data)
                                                                          :start (time-coerce/to-date (util/parse-datetime-local (:client_start event-data)))
                                                                          :end (time-coerce/to-date (util/parse-datetime-local (:client_end event-data)))
                                                                          :allDay (:all_day event-data)
                                                                          :title (str (:name (first (:collections event-data))) ": " (:name event-data))
                                                                          :complete_by (:complete_by event-data)})
                                                                       (:events response))))))
                                           (process-error)))

                            :event-click (fn [cal-ev ev view]
                                           (let [cal-ev (js->clj cal-ev)]
                                             (set-location (str "#/event/details/" (cal-ev "key") "/"))))
                            :height "auto"

                            :defaultDate  (tz/to-user-timezone (time-coerce/to-date (:start_time event)))

                            :eventRender (fn [event element view]
                                           (let [event-start-time-formatted (model/event-time-string-breadcrumb start-time "yyyy-MM-dd" )
                                                 each-event-date-formatted (.format (.-start event) "YYYY-MM-DD")
                                                 each-event-date-formatted-day (.format (.-start event) "D")
                                                 add-class (fn [classes] (.addClass (js/$ (str "#calendar td.fc-day-number[data-date="
                                                                                               each-event-date-formatted "]")) classes))]

                                             (if (= event-start-time-formatted each-event-date-formatted)
                                               (add-class "fc-has-event fc-current")
                                               (add-class "fc-has-event"))

                                             ;; FML...
                                             ;; spans for events
                                             (.html (js/$ (str "#calendar td.fc-day-number[data-date="
                                                               each-event-date-formatted "]"))

                                                    (str "<a class = \"fc-event-day \"
                                                         href =\"#/event/details/" (-> event .-key) "/\" >"  each-event-date-formatted-day "</a>"))

                                             element))
                            :hide-header-buttons? true

                            :header {:left "prev"
                                     :center "title"
                                     :right "next"}}]])

       [:footer.c-event-details__calendar-footer.o-margin-elements--xs
        (for [[view-keyword label] [[:month "Month"] [:list "List"]]]
          [:button {:on-click #(reset! view view-keyword) :class (when (= view-keyword @view) "active") :key view-keyword
                    ;;Do not show events list on non-reccurng events
                    :style (when (and (not (:recurring event)) (= view-keyword :list)) {:display "none"})} label])]])))


(defn calendar-container-dates [{:keys [start-time end-time all-day?]}]
  (let [ends-on-the-same-day? (time-core/equal? (time-core/at-midnight start-time) (time-core/at-midnight end-time))
        aformat #(if (zero? (time-core/minute %1)) "ha" "h:ma")

        date-format "EEE, MMMM d, yyyy"

        start-date-formatted (model/event-time-string-breadcrumb start-time date-format)
        end-date-formatted (model/event-time-string-breadcrumb end-time date-format)

        start-hour-formatted (model/event-time-string-breadcrumb start-time (aformat start-time))
        end-hour-formatted (model/event-time-string-breadcrumb end-time (aformat end-time))

        event-type (model/event-type start-time end-time all-day?)]

    (fn [{:keys [start-time end-time all-day?]}]
      [:div
       [:header
        [:h4.c-heading--no-top-border [:span "Events"]]
        [:p (str (model/event-time-string-breadcrumb start-time "MMMM") " " (model/event-time-string-breadcrumb start-time "yyyy"))]]

       [:main.c-event-details__calendar-dates
        [:h5 (model/event-time-string-breadcrumb start-time "EEEE")]
        [:h1 (model/event-time-string-breadcrumb start-time "d")]

        (case event-type
          :single-all-day "All day"
          :single-day [:span (str start-hour-formatted
                                  " - "
                                  end-hour-formatted)]


          :multi-all-day  [:div [:p [:small "End date: "]] end-date-formatted]

          :multi-all-day-same-year  [:div [:p [:small "End date: "]] (model/event-time-string-breadcrumb end-time  "EEE, MMMM d")]

          :multi-day [:span
                      [:span start-hour-formatted]
                      [:div [:p [:small "End date: "]] (str start-date-formatted " " end-hour-formatted)]])]])))

(defn occurrences-list-show-more [event]
  (let [occurrences (atom (:occurrence_slice event))
        next-key (catom (get-in event [:next :key]))
        previous-key (catom (get-in event [:previous :key]))
        items-key-set (catom (set (keep :key (:occurrence_slice event)) ))
        loading? (atom false)
        occurrences-scroll-element (catom nil)
        top? (catom nil)
        scroll-height-before (catom nil)

        load-fn (fn [event-key show-more-top?]
                  (let [event-key (if show-more-top? previous-key next-key )
                        key-keyword (if show-more-top? :previous :next)
                        items-removed-duplicates (fn [occurrence-slice]
                                                   (filterv (fn [occurrence] (not (contains? @items-key-set (:key occurrence))))
                                                            occurrence-slice))]

                    (reset! top? show-more-top?)
                    (reset! loading? true)

                    (->> (model/event-details-silent @event-key)
                        (p/map (fn [events-response]
                                 (if show-more-top?
                                   (swap! occurrences #(into (items-removed-duplicates (:occurrence_slice events-response)) %1))
                                   (swap! occurrences into (items-removed-duplicates (:occurrence_slice events-response))))
                                 (swap! items-key-set clojure.set/union (keep :key (:occurrence_slice events-response)))
                                 (reset! event-key (get-in events-response [key-keyword :key]))
                                 (reset! loading? false)))
                        (process-error))))

        show-more-li (fn [event-key top?] [:li.c-occurrences-scroll__show-more {:on-click #(load-fn event-key top?)
                                            :class (when @loading? "loading-small")}])]

    (reagent/create-class
      {:component-did-update (fn []
                               (let [scroll-height-after (.-scrollHeight @occurrences-scroll-element)
                                     delta-scroll-height (- scroll-height-after @scroll-height-before)]

                                 ;; https://bit.ly/2Gmzc76
                                 ;; http://blog.vjeux.com/2013/javascript/scroll-position-with-react.html
                                 (when @top? (set! (.-scrollTop @occurrences-scroll-element) delta-scroll-height))))

       :component-will-update (fn []
                               (reset! scroll-height-before (.-scrollHeight @occurrences-scroll-element)))

       :reagent-render (fn [event]
                         [:ul.c-occurrences-scroll {:ref (fn [elem] (reset! occurrences-scroll-element elem))}

                          (when @previous-key (show-more-li previous-key true))

                          (for [occurrence @occurrences]
                            ^{:key (:key occurrence)}
                            [:li.c-occurrences-scroll__occurrence
                             (when (= (:key event) (:key occurrence)) {:class "is-active"} )
                             [:a {:href (str "#/event/details/" (:key occurrence) "/")}
                              (model/event-time-string occurrence "M-d-yy")]])

                          (when @next-key (show-more-li next-key false))])})))

#_ (defn infinite-scroll-list [event load-fn options]
  (let [items (atom (:occurrence_slice event))
        loading? (atom nil)
        more-items-available? (catom true)
        next-key (catom (get-in event [:next :key]))
        previous-key (catom (get-in event [:previous :key]))
        items-key-set (catom (set (keep :key (:occurrence_slice event)) ))]

    (reagent/create-class

      {:display-name "infinite-scroll-list"

       :reagent-render
       (fn [event load-fn options]

         [:div.infinite-scroll
          [scroll/items-list @items (:key event) @loading?]

          [scroll/infinite-scroll {:can-show-more? more-items-available?
                            :load-fn (fn [scroll-at-top?]
                                       (let [event-key (if scroll-at-top? previous-key next-key )
                                             key-keyword (if scroll-at-top? :previous :next)
                                             items-removed-duplicates (fn [occurrence-slice]
                                                                        (filterv (fn [occurrence] (not (contains? @items-key-set (:key occurrence))))
                                                                                 occurrence-slice))]

                                         (reset! loading? (if scroll-at-top? :top :bottom ))

                                         (if @event-key
                                           (do
                                             (reset! more-items-available? true)
                                             (->> (load-fn @event-key)
                                                  (p/map (fn [events-response]
                                                           (if scroll-at-top?
                                                             (swap! items #(into (items-removed-duplicates (:occurrence_slice events-response)) %1))
                                                             (swap! items into (items-removed-duplicates (:occurrence_slice events-response))))
                                                           (swap! items-key-set clojure.set/union (keep :key (:occurrence_slice events-response)))
                                                           (reset! loading? nil)
                                                           (reset! event-key (get-in events-response [key-keyword :key]))))
                                                  (process-error)))

                                           (do
                                             (reset! loading? nil)
                                             (reset! more-items-available? false)))))}]
          ])})))
